import { render, staticRenderFns } from "./HeroBanner.vue?vue&type=template&id=50c70e6e&scoped=true&lang=pug&"
import script from "./HeroBanner.vue?vue&type=script&lang=js&"
export * from "./HeroBanner.vue?vue&type=script&lang=js&"
import style0 from "./HeroBanner.vue?vue&type=style&index=0&id=50c70e6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c70e6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50c70e6e')) {
      api.createRecord('50c70e6e', component.options)
    } else {
      api.reload('50c70e6e', component.options)
    }
    module.hot.accept("./HeroBanner.vue?vue&type=template&id=50c70e6e&scoped=true&lang=pug&", function () {
      api.rerender('50c70e6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/HeroBanner.vue"
export default component.exports